<template>
  <div class="ui segments">

    <div class="ui segment">
    <div class="ui breadcrumb">
    <router-link :to="{name:'home'}" class="section">Sākums</router-link>
    <span class="divider">/</span>
    <router-link :to="{name:'waiting-for-delivery'}" class="section">Gaida piegādi</router-link>
    <span class="divider">/</span>
    <div class="active section">Apskatīt</div>
  </div>


 </div>

 <div class="ui segment">
   <div class="ui warning icon message" v-if="order.warning && order.warning.indexOf('NOT-CONFIRMED;') > -1  && $route.query.approve != 'yes'">
     <i class="info circle icon"></i>
     <div class="content">
       <div class="header">
         Uzmanību!
       </div>
       <p>Lūdzu apstipriniet rītdienas BIOveikala Autoship pasūtījumu</p>
       <div class="ui custom_brown button" :class="{loading: showLoading}" tabindex="0" @click="confirmDelivery">
         <div class="visible content">Apstiprināt rītdienas piegādi</div>
       </div>
     </div>
   </div>
   <div class="ui positive icon message" v-if="order.confirmed && order.status >= 3">
     <i class="checkmark icon"></i>
     <div class="content">
       <div class="header">
         Paldies!
       </div>
       <p>BIOveikala Autoship pasūtījums tiks piegādāts <b>{{order.delivery_date}}</b></p>

     </div>
   </div>

  <div class="ui form">

    <!-- row -->
    <h3 class="ui dividing header">
      <i class="marker icon"></i>
      <div class="content">
        Piegādes informācija
      </div>
    </h3>
    <div class="two fields">
        <div class="field">
          <label>Adrese</label>
          <select class="ui fluid dropdown" disabled>
                <option v-for="item in address" :value="item.id" :selected="item.id == order.address_id ? true:false">
                  {{item.street}}<span v-if="item.house_no !=''">&nbsp;</span>{{item.house_no}}<span v-if="item.flat_no !=''">,&nbsp;</span>{{item.flat_no}}<span v-if="item.city_label !=''">,&nbsp;</span>{{item.city_label}}
                </option>
              </select>
        </div>
    </div>

    <!-- row -->

 <div class="two fields">
   <div class="ui calendar field" id="start_date" >
     <label>Piegādes datums</label>
     <div class="ui input left icon">
       <i class="calendar icon"></i>
       <input type="text" placeholder="Norādit piegādes datumu" :value="order.delivery_date" disabled>
     </div>
   </div>
 </div>

 <!-- goods row -->
 <h3 class="ui dividing header">
   <i class="shop icon"></i>
   <div class="content">
     Preces
   </div>
 </h3>



<div class="ui container">
  <div  class="ui attached segment" v-bind:class="{ loading: storeStatus.loading }">

    <div class="ui form">
      <!-- goods row -->
      <div class="ui divided items">
        <div v-for="item in order.order_items_list" class="item">
          <div class="ui tiny image">
            <img :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_80,h_117,c_lfill/product/'+item.good_id+'.jpg'">
          </div>
          <div class="content">
            <a class="header">{{item.goods_name}}</a>
            <div class="meta">
              <!-- <span class="cinema">Cena {{item.price_vat}} &euro; gab.<span v-if="item.bail_vat>0">, DN {{item.bail_vat}} &euro;</span></span> -->
            </div>
            <div class="description">
              <p>{{item.description}}</p>
            </div>
            <div class="extra">

              <div v-if="item.no_of_goods_return > 0" class="ui right floated inline fields" disabled>
                <label>Atgriezīšu: &nbsp; x </label>
                <div class="field">
                  <input type="text" placeholder="skaits" :value="item.no_of_goods_return" disabled style="width:70px" number>
                </div>
              </div>
              <div class="ui right floated inline fields">
                <label>Pasūtīšu: &nbsp; x </label>
                <div class="field">
                  <input type="text" placeholder="skaits" disabled :value="item.no_of_goods"  style="width:70px" number>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

 <div class="ui clearing hidden divider"></div>
</div>

  </div>

</div>

<div class="ui secondary segment">
  <h3 class="ui dividing header">
    <i class="money icon"></i>
    <div class="content">
      Kopsavilkums
    </div>
  </h3>


  <div class="ui two column grid">
    <div class="row">
      <div class="ui column form">

            <div class="ui field">
              <label>Apmaksas veids</label>
              <select class="ui fluid dropdown" disabled>
                <option value="3" :selected="order.payment_type == 3">Skaidrā saņemot preci</option>
                <option value="2" :selected="order.payment_type == 2">No konta</option>
              </select>
            </div>

        <div class="ui field">
            <label>Komentāri</label>
            <textarea rows="4" :value="order.notes" disabled></textarea>
          </div>
      </div>
      <div class="column">
        <div style="float:right;" v-if="order && order.id > 0">
          <div class="ui list" style="text-align:right; margin-top:30px">

             <div id="bail" class="item" v-if="order.bail != 0" style="color:#E12F2E" data-content="Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas">Drošības nauda: {{order.bail}} &euro;</div>
            <div id="delivery" class="item" v-if="order.delivery_amount != 0" style="color:#E12F2E" data-html="Piegādes maksa netiks pievienota, ja pasūtīsiet produktus par vismaz 20 EUR.">Piegāde: {{order.delivery_amount}} &euro;</div>
            <div class="item"><b>Kopsumma: {{order.total_amount_with_bail_and_vat}} &euro;</b></div>
             <!--<div class="item" v-if="order.bonus_earned>0" style="color:#21BA45">
             Bonus is available only after its delivered  <span id="bonus" data-content="Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei">Bonuss: + {{order.bonus_earned}} &euro; </span></div> -->

          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="column"></div>
      <div class="column">
        <div class="ui right floated buttons">
        <button class="ui button" @click="$router.push({name:'waiting-for-delivery'})">Atpakaļ</button>
        <div class="or" data-text="vai"></div>
        <button class="ui green button" @click="goToEditPage" :class="{ disabled: order.status != 3}" >Rediģēt</button>
        </div>
      </div>
    </div>
  </div>




    <div class="ui clearing hidden divider"></div>
</div>



  </div>

</template>

<script>

export default {


  data() {
      return {
          showLoading: false
      }
  },
 computed: {
   storeStatus() {
     return this.$store.state.orderStore.status
   },
   order() {
     return this.$store.state.orderStore.order;
   },
   user() {
     return this.$store.state.userStore.user
   },
   address() {
     return this.$store.state.addressStore.items
   }
 },


  activated(){

     var id = (this.$route.params.id) ? this.$route.params.id : 0;
      this.$store.dispatch('loadOrder',id).then((response) => {

        this.$store.dispatch('loadAddress').then(() => {

        });


        //if auto approve is set then approve order

        if(this.$route.query.approve == 'yes'){
          this.confirmDelivery();
        }

      }).catch((error) => {

        console.error('Order was not loaded')
        this.$router.push({
            name: 'waiting-for-delivery'
        });
      });



  },

  methods:{
      //confirm that customer will wait for autoship order
      confirmDelivery(){

        var order = JSON.parse(JSON.stringify(this.order));
        order.confirmed =  1;

        this.$store.dispatch('updateOrder', order);
      },

      goToEditPage() {

        // process is as follows:
        // order is copied to cart and user will modify cart not order.
        // Once user save data he will update order (if its still possible) and cart will be deleted
        // to prevent clashes with active cart, we will use autoshipCart store for frontend. For future could merge cart/autoship/and this into one
        this.$store.commit('SET_ORDER_ITEMS', [])
        this.$store.commit('SET_ORDER_DETAILS', {})
        this.$store.dispatch('convertOrderToCart',this.order).then((response) => {

          this.$router.push({
              name: 'waiting-for-delivery-edit',
              params: {
                  id: response.data.data.id
              }
          });

        }).catch((error) => {
          console.error(error)
          console.error('Order conversion failed')
        });

      },
  }

}
</script>



// WEBPACK FOOTER //
// WaitingForDeliveryViewPage.vue?636d17ec